const Form097EN = {
    stepName: {
        statement: "Important Notes",
        applicatInfo: "Application Information",
        confirmation: "Confirmation",
    },
    // headBar: {
    //     partA: "Part A: Particulars of the Vacant Post",
    //     partB: "Part B: Particulars and Selection Assessment on the Candidate",
    //     partC: "Part C: Declaration",
    //     partD: "Part D: Sexual Conviction Record Check (SCRC)",
    //     partE: "Part E: Performance Appraisal ",
    // },

    label: {
        rankOption: {
            gm: "GM",
            apsm: "APSM",
            cm: "CM",
            steam: "STEAM teacher (applicable to government primary school)",
            ltii: "LTII",
        },
        sourceOption: {
            subst: "Substituting",
            addit: "Additional teacher",
        },
        languageOption: {
            English: "English",
            Putonghua: "Putonghua",
        },
        teachingOption: {
            Yes: "Yes ",
            No: "No",
        },
        periodExtensionOption: {
            period: "Period of appointment",
            extension: "Extension of appointment",
        },
        typeSchoolOption: {
            Govt: "Govt",
            Aided: "Aided",
            Caput: "Caput",
            DSS: "DSS",
            Private: "Private",
        },
        workTimeOption: {
            fullTime: "Full-time",
            partTime: "Part-time",
        },
        determinSalaryOption: {
            carryForward: '"carry-forward" arrangement',
            icePlus:
                "assessment on the basis of prevailing starting salaries plus ICE",
            others: '"fit-in" / others (please specify): ',
        },
        headTypeOption: {
            schoolHead: "School Head",
            supervisor: "Designated School Head",
        },

        basisInfo: "Basic Information",
        schoolYear: "School Year:",
        schoolName: "Name of School:",
        scrn: "SCRN:",
        engName: "Name of teacher appointed",
        chiName: "Name of teacher appointed (Chinese)",
        // preReferNum: "Previous Application Reference number",
        hkid: "HKID:",
        refNo: "Application No. of teacher",
        refNotes:
            "Please refer to the updated List of Applicants for Temporary Teaching Posts in Government Schools.",
        refNo1: "(if applicable):",
        rank: "Rank:",

        substTitle1: "Substituting for",
        substRank: "(rank and / or name of the teacher on",
        substRank1: " establishment) for",
        substReason: "(reason) ",
        substFrom: "from",
        substTo: "to",
        substSubject: "(vacant period) Subject:",
        additSource: "Source of funding",

        languageRequire: "Meeting Language Proficiency Requirement:",
        EMITeaching:
            "Meeting the teacher capability criterion for non-language teacher adopting EMI teaching",
        periodExtension: "Period/Extension of appointment",
        salary: "Salary",
        mpsPt1: "(#1 MPS Pt.",
        mpsPt2: "(#2 MPS Pt.",
        wef: ") w.e.f.",
        incrementalDate: "Incremental date:",
        incrementalTitle: ") (i.e. next date of increment)",
        TrainingTitle: "Relevant Qualification(s) for the appointment:",
        universities: "(a) universities",
        teacherTraining: "(b) Teacher Training",

        universityName: "Name of Universities",
        universityDegree: "Degree Obtained",
        dateObtained: "Date obtained",
        trainName: "Name of Institution",
        trainDegree: "Degree / Certificate / Diploma Obtained",

        trainingNotes:
            "For teachers appointed to teach English / Putonghua, please make sure they meet the “Language Proficiency Requirement for English and Putonghua Teachers” and attach relevant certificates for verification. For details, please refer to the EDB website.",
        supDocuments:
            "Supporting Documents (e.g. Service certifications, Academic qualifications, Teacher training, LPR, proof of vacancy like sick leave cert / resignation letter / study leave application):",

        teachingExperience:
            "Recognized teaching experience (in chronological order):",
        schoolType: "Type of school",
        // Rank:"",
        anySalaryBar: "Any salary bar?",
        lastSalaryPoint: "Last Salary Point(MPS)",
        fullPartTime: "Full-time/ Part-time",
        fraction: "Fraction",
        employmentTime: "Date of employment",
        // employmentTo:"",
        effectiveDuration: "Effective duration",
        total: "Total",
        remark: "Remark",

        assessmentSalary:
            "Assessment of Salary: (please use additional sheets if necessary)",
        serviceBreak:
            "Break of service, i.e. longer than 45 days (before 1.9.2006) and/or longer than 1 year (after 1.9.2006)",
        usedSalary1: "Salary scale used: MPS Pt.",
        usedSalary2: "with Salary Bar Pt. at(",
        // nA: "Not available",

        determinSalary: "Salary determined by",
        othersSpecify: "(please specify)",
        hasDifficulty: "My school has recruitment difficulty",
        justification:
            "For salary point more than 5 increments, please provide justification",

        assessedBy: "Assessed by",

        endorsedBy: "Endorsed by",
        headType: "School Head / Designated School Head",
    },
    errorMsg: {
        lessOne: "This field need less than 1",
        fielDigits:
            "Previous Application Reference number must be exactly {{len}} digits",
        salaryRules: "#2 must be larger than #1",
        dateRules: "incremental date should be later than w.e.f.",
        refNo: "This field must be 6 digits.",
    },
    submittedDialog: {
        multiLayerSubmitMsg:
            "You are about to be redirected to sign for this application.",
    },
};
export default Form097EN;
